import crudActions from '@/store/crudActions'
import axios from '@/libs/axios'

const directionDcTypeExel = () => new Promise((resolve, reject) => {
  axios.get('/statistics/direction_dc_type_exel')
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      reject(error)
    })
})
export default {
  ...crudActions('directions'),
  directionDcTypeExel,

}
